import { apiCall } from './gqlClient';
const SENDMESSAGE_QUERY = "\n  query sendMessage($data: JSON!) {\n    sendMessage(data: $data)\n  }";
export const sendMessageApiCall = async _ref => {
  let {
    data
  } = _ref;
  return apiCall({
    query: SENDMESSAGE_QUERY,
    variables: {
      data
    }
  });
};
const SENDMESSAGEANAMNESI_QUERY = "\n  query sendMessageAnamnesi($data: customerAnamnesiNotificationInput!) {\n    sendMessageAnamnesi(data: $data)\n  }";
export const sendMessageAnamnesiApiCall = async _ref2 => {
  let {
    data
  } = _ref2;
  return apiCall({
    query: SENDMESSAGEANAMNESI_QUERY,
    variables: {
      data
    }
  });
};
const SENDREMINDERSUBSCRIPTION_QUERY = "\n  query sendReminderSubscription($subscriptionId: Int!) {\n    sendReminderSubscription(subscriptionId: $subscriptionId)\n  }";
export const sendReminderSubscriptionApiCall = async _ref3 => {
  let {
    subscriptionId
  } = _ref3;
  return apiCall({
    query: SENDREMINDERSUBSCRIPTION_QUERY,
    variables: {
      subscriptionId
    }
  });
};
const SENDREMINDEREXPIRINGMEMBERSHIP_QUERY = "\n  query sendReminderExpiringMembership($userMembershipId: Int!) {\n    sendReminderExpiringMembership(userMembershipId: $userMembershipId)\n  }";
export const sendReminderExpiringMembershipApiCall = async _ref4 => {
  let {
    userMembershipId
  } = _ref4;
  return apiCall({
    query: SENDREMINDEREXPIRINGMEMBERSHIP_QUERY,
    variables: {
      userMembershipId
    }
  });
};
const SENDREMINDERTOALLSUBSCRIPTIONINASESSION_QUERY = "\n  query sendReminderToAllSubscriptionInASession($sessionId: Int!) {\n    sendReminderToAllSubscriptionInASession(sessionId: $sessionId)\n  }";
export const sendReminderToAllSubscriptionInASessionApiCall = async _ref5 => {
  let {
    sessionId
  } = _ref5;
  return apiCall({
    query: SENDREMINDERTOALLSUBSCRIPTIONINASESSION_QUERY,
    variables: {
      sessionId
    }
  });
};